export default class VerifyMeRequest {
    email: string = '';
}